import clsx from "clsx";
import { CASE_TABS } from "@/lib/constants";
import type { CaseTab } from "@/lib/types";
import styles from "./styles.module.scss";

interface Props {
  selectedTab: CaseTab;
  setSelectedTab: (tab: CaseTab) => void;
}

export default function CaseTabs(props: Props) {
  return (
    <div className={"d-flex justify-content-start mb-4"}>
      <button
        data-testid="discovery-tab"
        type="button"
        className={clsx(
          "bg-white",
          styles.tab,
          props.selectedTab === CASE_TABS.DISCOVERY && styles.active,
        )}
        onClick={() => props.setSelectedTab(CASE_TABS.DISCOVERY)}
      >
        Discovery
      </button>
      <button
        data-testid="production-tab"
        type="button"
        className={clsx(
          "bg-white",
          styles.tab,
          props.selectedTab === CASE_TABS.PRODUCTION && styles.active,
        )}
        onClick={() => props.setSelectedTab(CASE_TABS.PRODUCTION)}
      >
        Production
      </button>

      <div className={`${styles.bottomLine} w-100`} />
    </div>
  );
}
